import { ButtonBase } from "@mui/material";
import styled from "styled-components";

const divMain = styled(ButtonBase)`
  &.MuiButtonBase-root {
    width: 100%;
    min-width: min-content;
    height: fit-content;
    display: flex;
    flex-direction: ${({ iconPosition = "" }) => iconPosition};
    justify-content: center;
    align-items: center;
    gap: 12px;
    padding: 12px 15px;
    box-shadow: unset;
    border-radius: 25px;
    border-width: 2px;
    border-style: solid;
    background-color: transparent;
    transition: all 0.4s;
    cursor: pointer;
    .txtLabel {
      font-family: "Roboto", Helvetica, sans-serif;
      font-weight: 700;
      font-size: ${({ textSize = 0 }) => textSize}px;
      line-height: ${({ textSize = 0 }) => textSize + 2}px;
      text-align: center;
      cursor: inherit;
    }
    > * {
      transition: inherit;
    }

    /*==========================================
		ESTILOS DE COLORES
		============================================*/
    &.BLACK_S1 {
      border-color: #000000;
      .txtLabel {
        color: #13131d;
      }
      &:hover {
        border-color: #717178;
        .txtLabel {
          color: #717178;
        }
        .btnIcon {
          color: #717178;
        }
      }
    }

    // MODO DESHABILLITADO
    &.Mui-disabled {
      border-color: #a0a0a0;
      .txtLabel {
        color: #a0a0a0;
      }
    }

    // MODO CARGANDO
    &.isLoading {
      pointer-events: none;
      cursor: default;
    }
  }
`;

export default {
  divMain,
};
